export default "__VITE_ASSET__DyOgezpk__"